import {
  Button,
  CompoundButton,
  Text,
  makeStyles,
  tokens,
} from '@coreai/fluentui-react';
import {
  ArrowLeft20Regular,
  BotSparkleRegular,
} from '@fluentui/react-icons';
import type { AgentProviderChoice } from './addConnectionTypes';

const AGENT_PROVIDERS: readonly AgentProviderChoice[] = [
  {
    type: 'AzureOpenAI',
    name: 'Azure OpenAI',
    description: 'Connect to an Azure OpenAI resource.',
  },
  {
    type: 'FoundryAgentServiceV2',
    name: 'Azure AI Foundry',
    description: 'Connect to a Foundry project using the Responses API.',
  },
  {
    type: 'V1ChatCompletionsService',
    name: 'OpenAI-compatible model',
    description: 'Connect with a chat completions endpoint and API key.',
  },
  {
    type: 'APIMGenAIGateway',
    name: 'API Management AI gateway',
    description: 'Connect through an API Management generative AI gateway.',
  },
];

const useStyles = makeStyles({
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalS,
    flexShrink: 0,
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
    gap: tokens.spacingHorizontalM,
  },
  choice: {
    minHeight: '88px',
    height: 'auto',
    justifyContent: 'flex-start',
    padding: tokens.spacingVerticalM,
  },
});

export interface AgentProviderChooserProps {
  onBack: () => void;
  onSelect: (provider: AgentProviderChoice) => void;
}

export const AgentProviderChooser = ({
  onBack,
  onSelect,
}: AgentProviderChooserProps) => {
  const styles = useStyles();

  return (
    <>
      <div className={styles.toolbar}>
        <Button
          appearance="subtle"
          icon={<ArrowLeft20Regular aria-hidden="true" />}
          aria-label="Back to connection types"
          onClick={onBack}
        />
        <Text weight="semibold">Choose a model provider</Text>
      </div>
      <div className={styles.grid} role="group" aria-label="Model providers">
        {AGENT_PROVIDERS.map((provider) => (
          <CompoundButton
            key={provider.type}
            className={styles.choice}
            icon={<BotSparkleRegular fontSize={32} aria-hidden="true" />}
            secondaryContent={provider.description}
            onClick={() => onSelect(provider)}
          >
            {provider.name}
          </CompoundButton>
        ))}
      </div>
    </>
  );
};
